import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import sxs from './_sxs'

const Reminder = () => (
    <Typography
        sx={(theme) => ({
            ...sxs.text,
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        })}
    >
        Vous avez modifié votre "Numéro personnel", la gestion de l'authentification forte (2FA) sera automatiquement
        désactivée lors de l'enregistrement. Pour re-activer le 2FA allez sur{' '}
        <Link
            style={{
                textDecoration: 'none',
            }}
            to="/security"
        >
            "Mon Compte - Gestion Sécurité".
        </Link>
    </Typography>
)

export default Reminder
